function mutationCart(itemsCart, code) {
  const lines = itemsCart.reduce(
    (items, line) => [
      ...items,
      {
        quantity: line.quantity,
        merchandiseId: `gid://shopify/ProductVariant/${line.id}`,
      },
    ],
    []
  );

  return JSON.stringify({
    query: `
      mutation createCart($cartInput: CartInput) {
        cartCreate(input: $cartInput) {
          cart {
            cost {
              checkoutChargeAmount {
                amount
              }
              subtotalAmount {
                amount
              }
            }
            discountCodes {
              applicable
              code
            }
          }
          userErrors {
            message
          }
        }
      }
    `,
    variables: {
      cartInput: {
        lines,
        discountCodes: code,
      },
    },
  });
};

async function createCartDiscount(code) {
  try {
    const cart = humantraCart.data;

    if (cart.items.length === 0 || !code) return;

    code = Array.isArray(code) ? code : [code];

    const data = await fetch(`https://${Shopify.shop}/api/2023-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '7e87ed8339ba9109a7b9218b8221083c',
      },
      body: mutationCart(cart.items, code),
    }).then(r => r.json());

    const discountInfo = data?.data?.cartCreate?.cart;

    if (!discountInfo || !discountInfo?.discountCodes?.[0].applicable) return { error: true };

    return discountInfo?.cost?.subtotalAmount?.amount ? { amount: discountInfo.cost.subtotalAmount.amount } : { error: true };
  } catch (error) {
    console.error(`Error: ${error.message}`);
    return { error: true };
  }
};

function fetchConfig(type = 'json') {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function serializeForm(form) {
  const obj = {};
  const formData = new FormData(form);
  const keys = formData.keys();
  for (const key of keys) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
}

window.humantraCart = {}

humantraCart.data = {}

humantraCart.discount = false

humantraCart.get = function () {
  const json = document.querySelector('#cart-json')
  const data = JSON.parse(json.innerHTML)
  humantraCart.data = data;
}

humantraCart.toggle = function (e) {
  if (e) e.preventDefault();
  $('body').toggleClass('open-cart')
}

humantraCart.sliderInit = function () {
  if (!document.querySelector('.cart-upsell-inner')) return;
  tns({
    container: '.cart-upsell-inner', nav: false, items: 1.7, loop: true,
    prevButton: '.cart-upsell-prev', nextButton: '.cart-upsell-next'
  })
}

humantraCart.render = function (data, open = true) {
  const wrapper = new DOMParser()
    .parseFromString(data.sections['side-cart'], 'text/html')
    .querySelector('#side-cart-container');
  const drawerWrapper = document.getElementById('side-cart-container');
  drawerWrapper.innerHTML = wrapper.innerHTML;

  humantraCart.get()

  const quantity = document.querySelector('span.site-header-cart--count')
  quantity.dataset.headerCartCount = humantraCart.data.item_count;

  humantraCart.sliderInit()

  $('.side-cart form[data-product-form]').on('submit', handleProductForm)

  if (open) setTimeout(() => {
    $('body').addClass('open-cart')
  }, 100);
};

function handleProductForm(e) {
  e.preventDefault();
  const body = JSON.stringify({
    ...JSON.parse(serializeForm(e.target)),
    sections: ['side-cart'],
    sections_url: window.location.pathname
  });
  fetch('/cart/add', { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then((parsedState) => {
      humantraCart.render(parsedState);
    })
    .catch((err) => {
      console.error('CART ERROR: ', err);
      // e.target.submit();
    })
}

class SideCart extends HTMLElement {
  constructor() {
    super();
    const toggles = this.querySelectorAll('[data-cart-toggle]')
    toggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => { humantraCart.toggle(e) })
    })
  }
}
customElements.define('side-cart', SideCart);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onChange.bind(this));
  }
  onChange(e) {
    this.updateQuantity(e.target.dataset.index, e.target.value);
  }
  updateQuantity(line, quantity) {
    const cart = document.querySelector('side-cart');
    if (cart) {
      cart.classList.add('loading');
      if (quantity === 0) {
        const item = cart.querySelector('#CartItem-' + line);
        if (item) item.classList.add('cart-item-remove');
      }
    }
    const body = JSON.stringify({
      line,
      quantity,
      sections: ['side-cart'],
      sections_url: window.location.pathname
    });
    fetch('/cart/change', { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        humantraCart.render(parsedState, false);
      }).catch((e) => {
        console.warn(e);
      }).finally(() => {
        if (cart)
          cart.classList.remove('loading');
      });
  }
}
customElements.define('cart-items', CartItems);

class QuantityInput extends HTMLElement {
  input;
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.querySelectorAll('span').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }
  onButtonClick(event) {
    event.preventDefault();
    const isPlus = event.target.dataset.quantity === 'plus';
    const value = parseInt(this.input.value)
    this.input.value = isPlus ? value + 1 : value - 1;
    const cartItems = this.closest('cart-items');
    cartItems.updateQuantity(this.input.dataset.index, parseInt(this.input.value));
  }
}
customElements.define('quantity-input', QuantityInput);

class DiscountElement extends HTMLElement {
  input;
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.button = this.querySelector('button');
    this.total = document.querySelector('side-cart [data-cart-total]');

    this.button.addEventListener('click', this.onButtonClick.bind(this))

    this.getDiscount()
  }
  getDiscount() {
    const data = localStorage.getItem('humantra-code')
    if (!data) return;
    humantraCart.discount = JSON.parse(data)
    this.button.dataset.remove = 'true'
    this.input.value = humantraCart.discount.code
    this.input.readOnly = true
    this.total.innerHTML = Theme.formatMoney(humantraCart.discount.amount, Theme.moneyFormat)
  }

  async onButtonClick() {
    if (!this.input.value) return;

    this.dataset.error = ''
    this.button.disabled = true

    if (this.button.dataset.remove === 'true') {
      localStorage.removeItem('humantra-code')
      this.button.dataset.remove = 'false'
      this.input.value = ''
      this.input.readOnly = false
      this.button.disabled = false
      this.total.innerHTML = Theme.formatMoney(humantraCart.data.items_subtotal_price, Theme.moneyFormat)
      return
    }
    const code = this.input.value
    const res = await createCartDiscount(code)
    if (res.amount) {
      localStorage.setItem('humantra-code', JSON.stringify({ code, amount: res.amount }))
      this.getDiscount()
    } else if (res.error) this.dataset.error = 'Discount code not applicable'

    this.button.disabled = false
  }
}
customElements.define('discount-element', DiscountElement);

function cartInit() {
  $('.site-header-cart-button, .cart-overlay').on('click', (e) => { humantraCart.toggle(e) })
  $('form[data-product-form]').on('submit', handleProductForm)
  humantraCart.sliderInit()
  humantraCart.get()
}

cartInit()
